import axios from "../../axios";
import { devUrl } from "../../settings";

const state = {
  tasks: [],
  tasksQuantity: null,
  annotations: [],
  deletingId: null
};

const getters = {
  tasks(state) {
    return state.tasks;
  },
  getTasksQuantity(state) {
    return state.tasksQuantity;
  },
  getTasksAnnotations(state) {
    return state.annotations;
  },
  getTasksDeletingId(state) {
    return state.deletingId;
  }
};

const mutations = {
  storeTasks(state, payload) {
    state.tasks = payload.results;
    state.tasksQuantity = payload.tasksCount;
  },
  storeTasksAnnotations(state, payload) {
    state.annotations = payload;
  },
  storeModalId(state, payload) {
    state.deletingId = payload;
  }
};

const actions = {
  async fetchTasks({ commit }, page) {
    let res = await axios.get(`/tasks/?limit=5&offset=${5 * page - 5}`);

    const tasksPromise = res.data.results.map(item => {
      return axios.get(item.scheme).then(res => {
        item.scheme = res.data.name;
        return item;
      });
    });

    let tasks = await Promise.all(tasksPromise);

    commit("storeTasks", {
      results: tasks,
      tasksCount: res.data.count
    });
  },
  async fetchAnnotations({ commit, state }, id) {
    const task = state.tasks.find(item => item.id === id);
    const datapointsUrls = task.datapoints;
    const annotations = [];

    for (let i = 0; i < datapointsUrls.length; i++) {
      await axios
        .get(datapointsUrls[i])
        .then(res => {
          annotations.push(res.data);
        })
        .catch(err => console.log(err));
    }
    console.log(annotations);
    commit("storeTasksAnnotations", annotations);
  },
  postTask({ commit }, data) {
    const token = localStorage.getItem("token");

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    return axios
      .post(`${devUrl}tasks/create_from_study/`, data, config)
      .then(res => console.log(res))
      .catch(err => console.log(err));
  },
  sendIdToModal({ commit }, id) {
    commit("storeModalId", id);
  },
  deleteTask({ dispatch }) {
    const token = localStorage.getItem("token");
    const id = state.deletingId;

    const config = {
      headers: {
        Authorization: "Token " + token
      }
    };

    axios
      .delete(`${devUrl}tasks/${id}`, config)
      .then(() => {
        dispatch("fetchTasks", 1);
        dispatch("sendIdToModal", null);
      })
      .catch(err => console.log(err));
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
